<template>
  <div class="card theme-form--dark">
    <header class="card__header">
      <h2>Copy Coupon</h2>
    </header>

    <div class="card__body">
      <CouponForm 
        :formName="formName" 
        @submit="submit"
        @created.once="fetchCoupon(original_id)">
        <el-row :gutter="32">
          <el-col :span="24">
            <ElButton type="primary" native-type="submit" :disabled="isLoading || !generatedCode">Create Coupon</ElButton>
            <ElButton
              @click="$router.push({ name: 'coupon-management' })"
              :disabled="isLoading"
            >Cancel</ElButton>
          </el-col>
        </el-row>
      </CouponForm>
    </div>
  </div>
</template>

<script>
import axios, { RepositoryError } from "../../repositories";
import { mapActions, mapGetters } from "vuex";
import { notify } from "../../utils";
import CouponForm from "./CouponForm";

export default {
  name: "CopyCoupon",
  components: {
    CouponForm
  },
  props: {
    original_id: {
      type: String | Number,
      required: true
    }
  },
  data() {
    return {
      formName: "coupon.single",
      generatedCode: "",
    };
  },
  methods: {
    ...mapActions("forms", ["setFields", "setStatus"]),
    async submit(fields) {
      if (this.isLoading || !this.generatedCode) {
        return;
      }
      try {
        this.setStatus({
          form: this.formName,
          status: "loading"
        });
        const {data} = await axios.post("/discounts/store", {
          ...fields,
          copy: true,
          generated_code: this.generatedCode,
        });
        notify(data.message, data.needEmailApprove ? "warning" : "success");

        await this.$router.push({ name: "coupon-management" });
      } catch (err) {
        if (!(err instanceof RepositoryError)) {
          throw err;
        }
      } finally {
        this.setStatus({
          form: this.formName,
          status: "idle"
        });
      }
    },
    async fetchCoupon(id) {
      this.generatedCode = "";
      try {
        this.setStatus({
          form: this.formName,
          status: "loading"
        });

        const {data} = await axios.get(`/discounts/single/${id}`, {params: {copy: true}});
        const tracker = data.code_type.split("/");

        this.setFields({
          form: this.formName,
          fields: {
            ...data,
            amount: parseFloat(data.amount) || 0,
            tracker_prefix: tracker[0] || "",
            tracker_detail: tracker[1] || ""
          }
        });
        this.generatedCode = data.code;
      } catch (err) {
        if (!(err instanceof RepositoryError)) {
          throw err;
        }
      } finally {
        this.setStatus({
          form: this.formName,
          status: "idle"
        });
      }
    }
  },
  computed: {
    ...mapGetters("forms", ["getStatus"]),
    isLoading() {
      return this.getStatus({ form: this.formName }) === "loading";
    }
  }
};
</script>
